<template>
  <a-modal
    v-bind="$attrs"
    v-on="$listeners"
    :visible="visible"
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button key="cancel" :loading="loading" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
        确定
      </a-button>
    </template>
    <a-form v-bind="formItemLayout" :form="modifyForm" @submit="handleOk">
      <a-form-item label="渠道号">
        <a-input
          disabled=""
          placeholder="请输入渠道号"
          class="modal-form"
          v-decorator="
           ['channelNo', { initialValue: item.channelNo, rules: [{ required: false, type: 'string', message: '渠道号不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道名称">
        <a-input
          placeholder="请输入渠道名称"
          class="modal-form"
          v-decorator="
           ['channelName', { initialValue: item.channelName, rules: [{ required: true, type: 'string', message: '渠道名称不能为空' }] }]"
        ></a-input>
      </a-form-item>
      <a-form-item label="渠道类型">
        <a-input
          class="modal-form"
          placeholder="请选择渠道类型"
          disabled
          v-decorator="
           ['channelTypeDesc', { initialValue: item.channelTypeDesc, rules: [{ required: false, validateTrigger: 'change', type: 'string', message: '渠道类型不能为空' }] }]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="渠道实体">
        <a-input
          class="modal-form"
          placeholder="请输渠道实体"
          v-decorator="
           ['channelEntity', { initialValue: item.channelEntity, rules: [{ required: false, message: '渠道实体不能为空' }] }]"
        >
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { formItemLayout } from '@/config'

export default {
  name: 'UpdateChannel',
  props: {
    channelList: {
      type: Array
    },
    item: {
      type: Object,
      required: true,
      default: () => {
        return {
          momentStart: null,
          momentEnd: null
        }
      }
    }
  },
  data: () => ({
    visible: false,
    loading: false,
    modifyForm: null,
    formItemLayout: Object.assign({}, formItemLayout, {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 18
      }
    }),
    rules: {
      startTime: [{
        type: 'object',
        required: true,
        message: '请选择开始时间'
      }],
      endTime: [{
        type: 'object',
        required: true,
        message: '请选择结束时间'
      }]
    },
    platList: [],
    startOpen: false,
    endOpen: false
  }),
  created () {
    this.modifyForm = this.$form.createForm(this, { name: 'modifyForm' })
  },
  methods: {
    handleCancel () {
      this.visible = false
      this.modifyForm.resetFields()
    },
    handleOk () {
      this.modifyForm.validateFields(async (err, values) => {
        if (!err) {
          const params = {
            ...this.item,
            ...values
          }
          this.loading = true
          const { succ } = await this.$http.channel.channelUpdate(params)
          this.loading = false
          if (succ) {
            this.$message.success('修改成功！')
            this.handleCancel()
            this.$emit('success')
          }
        }
      })
    },
    handleClose () {
      this.startOpen = false
      this.endOpen = false
    }
  }
}
</script>

<style scoped lang="less">
@import "~@/components/modal-form.less";
</style>
